<template>
  <div class="menu-items-editor">
    <div id="left-menu" class="menu-items-editor__left">
      <section
        v-for="(category, index) in categories"
        :key="`category-${category.index}`"
        class="border-b border-blue-100 flex flex-col"
      >
        <template v-if="isNotOnSiteOrderCategory(category.index)">
          <menu-items-editor-category-entrees
            :menu="menu"
            :category="category"
            :error-category-messages="errorCategoriesMessages[index]"
            :selected-entree-index="displayEntree && displayEntree.index"
            :show-remove-button="menu.categories.length > 1"
            @add-new-entree="onAddEntree"
            @entree-select="onShowEntreeDetails"
            @remove-category-with-entrees="removeCategoryWithEntrees"
            @remove-entree="removeEntree"
            @copy-entree="copyEntree"
          />
        </template>
      </section>
      <div
        v-if="showAddCategoryBtn"
        class="bg-blue-50 flex items-center justify-between pl-2 pr-4 py-2"
      >
        <w-button
          color-type="secondary"
          size="sm"
          type="link"
          @click="onAddCategory()"
        >
          <i class="icon-plus mr-2" />
          新增類別
        </w-button>
      </div>
    </div>
    <div id="drag-bar" class="drag-bar">
      <div class="box-border relative" />
      <i class="absolute icon-move top-1/2 transform -translate-x-2">
        <span class="path1" />
        <span class="path2" />
      </i>
    </div>
    <div
      :class="{ 'bg-light-gray-100': isAddOptionMode }"
      class="flex-grow min-w-[250px] overflow-auto"
    >
      <div v-if="!displayEntree" class="flex flex-col !px-6 py-3">
        <section class="pb-2">
          <label class="font-medium">
            品項資訊
          </label>
        </section>
        <div class="flex flex-col">
          <p class="mb-12 !mt-7 text-gray-500 text-sm">
            選擇左方品項，以查看/設定詳細資訊。
          </p>
          <img
            :src="require('@/assets/images/note.jpg')"
            alt="沒有品項"
            class="self-center"
          />
        </div>
      </div>
      <add-menu-option
        v-else-if="isAddOptionMode"
        @add-option="onAddOption"
        @toggle-option-create-mode="onToggleOptionMode"
      />
      <menu-items-editor-entree-details
        v-else
        :categories="categories"
        :entree="displayEntree"
        @add-option-to-entree="addOptionToCurrentEntree"
        @remove-entree="removeEntree"
        @toggle-option-create-mode="onToggleOptionMode"
      />
    </div>
  </div>
</template>

<script>
import MenuItemsEditor from './MenuItemsEditor';

export default MenuItemsEditor;
</script>

<style lang="scss" scoped>
@import 'MenuItemsEditor';
</style>
